import { platformRead } from './http'

// 聚合只读接口；分享页通过独立 readClient 使用发布授权身份，不复用编辑账号。
export const queryDeviceStatus = (data, options = {}) => platformRead({
  method: 'post', url: '/jetlinks/visualization/device-status/_query', data
}, options)
